import React, { Component } from 'react'
import { pushContentToMatomo } from '../utils/matomo'

class ToggleSwitch extends Component {
  constructor(props) {
    super(props);

    this.state = { checked: this.props.defaultChecked }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({ checked: nextProps.defaultChecked });
  }

  onChange = e => {
    this.setState({
      checked: e.target.checked
    });
    
    if (e.target.checked) {
      e.target.nextElementSibling.lastElementChild.className = 'toggle-switch-switch switch-tick'
    } else {
      e.target.nextElementSibling.lastElementChild.className = 'toggle-switch-switch switch-cross'
    }

    this.props.apiCallFunc(e.target.checked)

    var contextData = {
      "savedSearchId": this.props.savedSearchId,
      "savedSearchName": this.props.savedSearchName,
      "contentSetName": this.props.contentSetName,
      "articleTitle": this.props.contentTitle,
      "contentTypeName": this.props.contentTypeName,
      "areasOfInterest": this.props.areasOfInterest
    }

    pushContentToMatomo(this.props.datagmue, this.props.datagmupn, this.props.datagmuc, this.props.datagmua, e.target.checked, contextData)
  };

  render() {
    return (
      <div className="toggle-wrapper">
        <div
          className='toggle-switch small-switch'
        >
          <input
            type='checkbox'
            name={this.props.Name}
            className='toggle-switch-checkbox'
            id={this.props.id}
            checked={this.state.checked}
            onChange={this.onChange}
          />
          {this.props.id ? (
            <label className='toggle-switch-label' htmlFor={this.props.id}>
              <span
                className={
                  this.state.checked
                    ? 'toggle-switch-inner'
                    : 'toggle-switch-inner toggle-switch-unchecked'
                }
              />
              <span
                className={
                  this.state.checked
                    ? 'toggle-switch-switch switch-tick'
                    : 'toggle-switch-switch switch-cross'
                }
              />
            </label>
          ) : null}
        </div>
        <span className='toggle-text'>{this.props.text}</span>
      </div>
    )
  }
}

export default ToggleSwitch
